module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-it.7c276f962be094651968.svg";